module.exports = __webpack_public_path__ + "img/sign_toast.ce233c8f.png";